'use strict';

import CONTENTO_ACCESSIBILITIES from './ContentoAccessibilities';

const AccessServiceTypes = {
    NONE: 'none',
    AUDIODESCRIPTION: 'audioDescription',
    SIGNINTERPRETATION: 'signInterpretation',
    LIVECAPTIONING: 'liveCaptioning',
    SIGN_LANGUAGE: 'signLanguage',
};

export const SIGNINTERPRETATION = 'teckenspråkstolkat';
export const AUDIODESCRIPTION = 'syntolkat';
export const DEFAULT = 'utan tolkning';

export function getAccessServiceDescription(accessService) {
    if (accessService === AccessServiceTypes.NONE || accessService === CONTENTO_ACCESSIBILITIES.DEFAULT) {
        return DEFAULT;
    } else if (
        accessService === AccessServiceTypes.AUDIODESCRIPTION ||
        accessService === CONTENTO_ACCESSIBILITIES.AUDIO_DESCRIBED
    ) {
        return AUDIODESCRIPTION;
    } else if (
        accessService === AccessServiceTypes.SIGNINTERPRETATION ||
        accessService === CONTENTO_ACCESSIBILITIES.SIGN_INTERPRETED
    ) {
        return SIGNINTERPRETATION;
    }
}

export function mapToNewAccessService(accessService) {
    if (
        accessService === AccessServiceTypes.AUDIODESCRIPTION ||
        accessService === CONTENTO_ACCESSIBILITIES.AUDIO_DESCRIBED
    ) {
        return CONTENTO_ACCESSIBILITIES.AUDIO_DESCRIBED;
    } else if (
        accessService === AccessServiceTypes.SIGNINTERPRETATION ||
        accessService === CONTENTO_ACCESSIBILITIES.SIGN_INTERPRETED ||
        accessService === AccessServiceTypes.SIGN_LANGUAGE
    ) {
        return CONTENTO_ACCESSIBILITIES.SIGN_INTERPRETED;
    }

    return CONTENTO_ACCESSIBILITIES.DEFAULT;
}

export function hasAccessService(accessService) {
    return Boolean(getAccessServiceDescription(accessService));
}

export default AccessServiceTypes;
